<script setup lang="ts">
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { computed } from 'vue';

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: string[] | number[] | boolean[]
  title: string
  items: {
    value: string | number | boolean,
    label: string,
  }[]
  selectedItem: string[] | number[] | boolean[]
  cols: number
  windowInnerWidth: number
  errors: string[]
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})
</script>
<template>
  <div class="mb-4 operation-office-radio-form">
    <v-row class="radio-form pl-4 pr-3">
      <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
        <h6 class="pt-2 pl-4" style="font-weight: bold">{{ props.title }}</h6>
      </v-col>
      <v-col :cols="cols">
        <v-radio-group v-model="modelValue" class="radio-group-row pt-2">
          <template v-for="item in items" :key="item.value">
            <v-radio :value="item.value" :label="item.label" color="blue" />
          </template>
        </v-radio-group>
        <ValidationErrors
          :messages="errors"
        />
      </v-col>
    </v-row>
  </div>
</template>
<style>
.radio-form .radio-group-row .v-selection-control-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.operation-office-radio-form .v-label {
  font-size: 14px;
}
</style>
